import { EnumService } from './../services/enum.service';
import { BannerList } from './../../../modals/banner-list';
import { Items } from './../../../modals/items';
import { ProductService } from 'src/app/components/shared/services/product.service';
import { Component, OnInit, Input } from '@angular/core';
import { Product } from 'src/app/modals/product.model';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-categories-section',
  templateUrl: './categories-section.component.html',
  styleUrls: ['./categories-section.component.sass']
})
export class CategoriesSectionComponent implements OnInit {
  bannerList: BannerList[];
  public prod: any[]=[];
  public itemsBrows:any[] = [];
  private loader:boolean = true;
  constructor(
    private productService: ProductService
  ) {
    
   }
  

  ngOnInit() {
    this.itemsBrows = [];
    this.productService.getBannerBrowse().subscribe((res: any) => {
      // this.prod = res.itemsEC_Browse;
      res.itemsEC_Browse.forEach(element => {
        this.prod.push({
          idItemEC:element.idItemEC,
          TItemEC:element.TItemEC,
          TItemECNom:element.TItemECNom,
          idItem:element.idItem,
          Marca:element.Marca,
          Codigo:element.Codigo,
          Nro:element.Nro,
          NombreItm:element.NombreItm.substring(0,34),
          UniMed:element.UniMed,
          UniMedDeno:element.UniMedDeno,
          CodigoBarras:element.CodigoBarras,
          PV1:element.PV1,
          PV2:element.PV2,
          PV3:element.PV3,
          PV4:element.PV4,
          PV5:element.PV5,
          PV6:element.PV6,
          PorcDscto:element.PorcDscto,
          Otros:element.Otros,
          ImagenP:element.ImagenP,
          ClicCant:element.ClicCant,
          ValCant:element.ValCant,
          ValSum:element.ValSum,
          ValProm:element.ValProm,
          Habilitado:element.Habilitado,
          Mostrar:element.Mostrar,
          OrdenIEC:element.OrdenIEC,
        })  
      });
      
    });
    
  }

  
}
